import { Dispatch, AnyAction } from 'redux';
import { action } from 'typesafe-actions';
import { AlertActionTypes, AlertTypes } from './types';

const showAlert = (type: AlertTypes, message: string) =>
  action(AlertActionTypes.SHOW_ALERT, { type, message });
const hideAlertAction = () => action(AlertActionTypes.HIDE_ALERT);

export const alertSuccess = (message: string) => {
  return (dispatch: Dispatch) => {
    dispatch(showAlert(AlertTypes.Success, message));
    setTimeout(() => {
      dispatch(hideAlertAction());
    }, 5000);
  };
};

export const alertError = (err: Error) => {
  return (dispatch: Dispatch<AnyAction>) => {
    const message = err.message ? err.message : err.toString();
    console.error(err);
    dispatch(showAlert(AlertTypes.Error, message));
  };
};

export const hideAlert = () => {
  return (dispatch: Dispatch) => {
    dispatch(hideAlertAction());
  };
};



// WEBPACK FOOTER //
// ./src/store/alert/actions.ts